module.exports = __webpack_public_path__ + "static/media/006_iOS - 6 - MENU.a490e8a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/kp/006_iOS - 6 - MENU.png
// module id = 503
// module chunks = 0